export const DashboardNutritionInspiration = {
  bindings: {
    isLoading: '<',
    items: '<',
  },

  template: `
    <div class="dashboard-nutrition-inspiration">
      <dashboard-carousel>
        <dashboard-carousel-header>
          <h4>
            <current-day>#FoodInspiration</current-day>
          </h4>
        </dashboard-carousel-header>
        <dashboard-carousel-body>
          <carousel list="$ctrl.items">
            <div class="carousel-slide-wrapper"
              ng-repeat="item in $ctrl.items track by $index">
              <div class="carousel-slide">
                <card-recipe
                  recipe="item"
                  on-click="$ctrl.onClick(item.id)">
                </card-recipe>
              </div>
            </div>
          </carousel>
        </dashboard-carousel-body>
        <dashboard-carousel-footer>
          <span class="card-badge badge rounded bg-green text-teal-dark p-0">
            <i class="icon-voome-flame text-teal-dark"></i>
          </span>
          <span class="pl-2 small font-size-sm-base">
            Based on your <a ui-sref="profile">Profile</a>
            <span class="px-2 text-gray">|</span>
            <a ui-sref="nutrition.recipes">All Recipes</a>
          </span>
        </dashboard-carousel-footer>
      </dashboard-carousel>
    </div>`,

  controller($state) {
    'ngInject';

    return {
      onClick(recipeId) {
        $state.go('nutrition.recipes.detail', { recipeId });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/NutritionInspiration.js